import { ApiResponse } from "@/types/apiTypes";
import { createApi } from "@reduxjs/toolkit/query/react";
import { normalBaseQuery } from "../BaseQuery";
import type { RowResult } from "@/types/models";

export type ExecutionLogSummary = {
  _id: string;
  excel_doc_id?: string;
  file_name: string;
  file_link: string;
  operation_mode: "insert" | "update" | "upsert";
  total: number;
  success: number;
  error_count: number;
  skipped: number;
  executed_at: string;
};

export type ExecutionLogDetail = ExecutionLogSummary & {
  results: RowResult[];
};

export const executionLogApi = createApi({
  reducerPath: "executionLogApi",
  baseQuery: normalBaseQuery,
  tagTypes: ["ExecutionLogList"],
  endpoints: (builder) => ({
    getExecutionLogs: builder.query<ApiResponse<ExecutionLogSummary[]>, void>({
      providesTags: ["ExecutionLogList"],
      query: () => ({ url: "admin/execution-log/", method: "GET" }),
    }),
    getExecutionLogById: builder.query<ApiResponse<ExecutionLogDetail>, string>({
      query: (id) => ({ url: `admin/execution-log/${id}`, method: "GET" }),
    }),
    createExecutionLog: builder.mutation<
      ApiResponse<ExecutionLogDetail>,
      {
        execution: {
          excel_doc_id?: string;
          file_name: string;
          file_link?: string;
          operation_mode: "insert" | "update" | "upsert";
          total: number;
          success: number;
          error_count: number;
          skipped: number;
          results: RowResult[];
        };
      }
    >({
      query: (data) => ({
        url: "admin/execution-log/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ExecutionLogList"],
    }),
  }),
});

export const {
  useGetExecutionLogsQuery,
  useGetExecutionLogByIdQuery,
  useCreateExecutionLogMutation,
} = executionLogApi;
